import axios from 'axios';
import { API } from '../config';

axios.defaults.headers.post['Access-Control-Allow-Origin'] = "*";
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';

class DadosGeograficosService {

  getEstados() {
    return axios.get(API + "/estados")
  }

  getBairros() {
    return axios.get(API + "/bairros")
  }

  getMunicipios() {
    return axios.get(API + "/municipios")
  }

  getMunicipiosLogado() {
    return axios.get(API + "/municipios/usuario-logado")
  }

  pesquisarMunicipios(id) {
    return axios.get(API + "/municipios/listar-por-estado/" + id);
  }
  pesquisarBairros(id) {
    return axios.get(API + "/bairros/listar-por-municipio/" + id);
  }

  getNacionalidades() {
    return axios.get(API + "/nacionalidades")
  }
}

const instanceDadosGeograficos = new DadosGeograficosService();
export default instanceDadosGeograficos;